import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify'
import Paginacion from 'components/Paginacion'
import api from 'api/api'

import './wiki.css'
import NuevaWiki from './NuevaWiki'
import { DEFAULT_FETCH_CUANTOS } from 'utils/constants'
import { debounce } from 'utils/debounce'
import VerWiki from './VerWiki'
import EliminarWiki from './EliminarWiki'
import EditarWiki from './EditarWiki'


function WikiPlantas(props) {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(DEFAULT_FETCH_CUANTOS)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [wikis, setWikis] = useState([])
	const [wikiActual, setWikiActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')
	const [etiquetas, setEtiquetas] = useState([])

	const sinImagenUrl = 'https://via.placeholder.com/80x80?text=Sin+imagen'

	const opcionesCuantosMostrar = [10, 25, 50]

	const refreshConfig = async () => {
		try {
			const { datos } = await api.get('p/config-wiki')
			setEtiquetas(datos.etiquetas)
		} catch (error) {
			toast.error('Error ')
		}
	}

	const refreshWikis = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('p/ver-wiki', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					nombre: [filtroBusqueda],
					etiqueta: [filtroBusqueda]
				}
			})

			setWikis(datos.plantas)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshWikis()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshWikis()
		}
	}, [paginaAct])

	const handleAction = (wiki, cual) => {
		setWikiActual(wiki, setQueMostrar(cual))
	}

	const subirArchivo = async (archivo) => {
		// Primero sube el archivo, luego crea el socio
		const serverData = new FormData();
		serverData.append('foto', archivo)
		let multimediaId = null

		try {
			const { datos, msg } = await api.post('a/multimedia', serverData)
			multimediaId = datos.id
		} catch (error) {
			toast.error('Error ')
		}

		return multimediaId
	}

	const nuevaWiki = async (data) => {
		const enviar = { ...data }
		if (data.imagen) {
			enviar.multimediaId = await subirArchivo(data.imagen)
		}
		delete enviar.imagen

		try {
			const { msg } = await api.post('a/wiki', enviar)
			refreshConfig()
			refreshWikis()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const editarWiki = async (data) => {
		const enviar = { ...data }
		if (data.imagen) {
			enviar.multimediaId = await subirArchivo(data.imagen)
		}
		delete enviar.imagen

		try {
			const { msg } = await api.put('a/wiki/' + data.id, enviar)
			refreshConfig()
			refreshWikis()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const eliminarWiki = async (id) => {
		const { msg } = await api.delete('a/wiki/' + id)
		refreshConfig()
		refreshWikis()
		setQueMostrar('')
		toast.success(msg)
	}

	useEffect(() => {
		if (!loading) {
			refreshConfig()
			refreshWikis()
		}
	}, [])


	// render
	return (
		<Container fluid id="wiki" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Wiki plantas</h1>
					<hr />
				</Col>
			</Row>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">plantas</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col>
					<Button variant="primary" onClick={() => setQueMostrar('nueva')} className="mt-2"><i className="fa fa-plus"></i> Nueva</Button>
				</Col>
			</Row>
			{/* Lista wiki */}
			<Row>
				<Col sm={12} lg={8}>
					{loading ? (
						<Spinner
							animation="border"
							size="lg"
							role="status"
							aria-hidden="true"
							variant="primary"
							className="my-3"
						/>
					) : (
						wikis.length === 0 ? (
							<Alert variant="info">No se encontraron entradas de wiki plantas</Alert>
						) : (
							wikis.map((wiki) => {
								return (
									<div key={wiki.id} className={`wiki border-primary`}>
										<div className="img-wrapper">
											<img src={wiki.imagen ? process.env.REACT_APP_API_URL + wiki.imagen.url : sinImagenUrl} alt="imagen" />
										</div>
										<div className="data">
											<div className="nombre">{wiki.nombre}</div>
											<div className="familia">{wiki.familia}</div>
											<div className="etiquetas">{wiki.etiquetas.map(elem => elem.nombre).join(', ')}</div>
										</div>
										<div className="fecha">{wiki.fechaCreacion.substr(0, 16)}</div>
										<DropdownButton
											as={ButtonGroup}
											title={<i className="fa fa-ellipsis-v"></i>}
											drop="end"
										>
											<Dropdown.Item eventKey="1" onClick={() => handleAction(wiki, 'ver')}><i className="fa fa-eye"></i> Ver</Dropdown.Item>
											<Dropdown.Item eventKey="2" onClick={() => handleAction(wiki, 'editar')}><i className="fa fa-pencil"></i> Editar</Dropdown.Item>
											<Dropdown.Item eventKey="2" onClick={() => handleAction(wiki, 'eliminar')} variant="danger"><i className="fa fa-trash"></i> Eliminar</Dropdown.Item>
										</DropdownButton>
									</div>
								)
							})
						)
					)}
					<Col>
						<Paginacion
							pagina={paginaAct}
							numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
							setPagina={setPaginaAct}
						/>
					</Col>
				</Col>
			</Row>

			{/* Panel Nuevo */}
			{queMostrar === 'nueva' && (
				<NuevaWiki
					etiquetasExistentes={etiquetas}
					guardar={nuevaWiki}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{wikiActual && queMostrar === 'ver' &&
				<VerWiki
					wiki={wikiActual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{wikiActual && queMostrar === 'editar' &&
				<EditarWiki
					wikiOriginal={wikiActual}
					etiquetasExistentes={etiquetas}
					setQueMostrar={setQueMostrar}
					guardar={editarWiki}
				/>
			}
			{/* Modal Delete */}
			{
				wikiActual && queMostrar === 'eliminar' &&
				<EliminarWiki
					wiki={wikiActual}
					setQueMostrar={setQueMostrar}
					eliminar={eliminarWiki}
				/>
			}
		</Container>
	);
}

export default WikiPlantas